<script setup>
import { computed } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import MarketingCloudSidebar from 'dashboard/components/widgets/conversation/MarketingCloudSidebar.vue';
// import ChannelInfo from 'dashboard/components-next/Conversation/ChannelInfo.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

const currentAccount = useMapGetter('accounts/getAccount');

const account = computed(() => {
  return currentAccount.value(props.currentChat.account_id);
});

const hasMarketingCloudTenantId = computed(() => {
  return account.value?.custom_attributes?.marketing_cloud_tenant_id;
});

// 获取当前应该显示的侧边栏类型：'contact' 或 'marketing_cloud'
const sidebarType = computed(() => {
  return uiSettings.value.sidebar_type || 'contact';
});

const activeTab = computed(() => {
  const { is_contact_sidebar_open: isContactSidebarOpen } = uiSettings.value;

  if (isContactSidebarOpen) {
    return 0;
  }
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  if (isSmallScreen.value && uiSettings.value?.is_contact_sidebar_open) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
    });
  }
};
</script>

<template>
  <div
    v-on-click-outside="() => closeContactPanel()"
    class="bg-n-surface-2 h-full overflow-hidden flex flex-col fixed top-0 z-40 w-full max-w-sm transition-transform duration-300 ease-in-out ltr:right-0 rtl:left-0 md:static md:w-[320px] md:min-w-[320px] ltr:border-l rtl:border-r border-n-weak 2xl:min-w-[360px] 2xl:w-[360px] shadow-lg md:shadow-none"
    :class="[
      {
        'md:flex': activeTab === 0,
        'md:hidden': activeTab !== 0,
      },
    ]"
  >
    <!-- 联系人信息面板 -->
    <ContactPanel
      v-if="!hasMarketingCloudTenantId || sidebarType === 'contact'"
      v-show="activeTab === 0"
      :conversation-id="currentChat.id"
      :inbox-id="currentChat.inbox_id"
    />
    <!-- 营销云面板 -->
    <MarketingCloudSidebar
      v-if="hasMarketingCloudTenantId && sidebarType === 'marketing_cloud'"
      v-show="activeTab === 0"
      :current-chat="currentChat"
    />
  </div>
</template>
